import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { useLocation } from "react-router-dom";
import {
  MdDeleteOutline,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";
import { sliceWords } from "../../../../../../../utils/functions";
import { useDispatch, useSelector } from "react-redux";
import { checkAccessFn } from "../../../../../../../utils/checkAccess";
import useSearchPagination from "../../../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import Highlighter from "react-highlight-words";

export default function ListDataTermsAndCondition({
  list = [],
  editData,
  deleteData,
  loading,
  onStatusChanger,
  titles = [],
  component,
}) {
  const location = useLocation();
  const currentQuotationId =
    location.state?.quotationId || location.pathname.split("/")[3];
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  const {
    Pagination,
    Search,
    currentList,
    NoDataFound,
    PaginationIndex,
    CountPerPage,
  } = useSearchPagination(list);

  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setDataLoaded(true);
    }, 2000);
  }, [list]);

  const [searchWords, setSearchWords] = useState([]);
  return (
    <div className="pt-2">
      <div className="flex md:flex-row flex-col  justify-between items-end">
        <Search
          searchKey={["particulars", "remark"]}
          setSearchWords={setSearchWords}
        />
        <CountPerPage />
        <p className="text-sm w-full text-right font-medium mb-1 xl:hidden block">{`Slide / scroll to right >`}</p>
      </div>
      <div
        className={`grid  grid-cols-table-5 auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline max-w-lg sm:max-w-sm md:max-w-prose lg:max-w-none rounded-md textTransformNone`}
      >
        {titles.map((t, index) => (
          <p key={index} className="font-semibold uppercase">
            {t}
          </p>
        ))}
        {list.length <= 0 && !dataLoaded && (
          <div className="flex justify-center items-center gap-3 mt-5 w-full col-span-5">
            <p>Loading</p>
            <CgSpinner className="animate-spin" />
          </div>
        )}
        {dataLoaded && <NoDataFound />}

        {currentList.map((l, index) => (
          <React.Fragment key={index}>
            <PaginationIndex index={index} />

            <p className="textTransformNone">
              <Highlighter
                className="textTransformNone"
                searchWords={searchWords}
                autoEscape={true}
                textToHighlight={l.particulars || "-"}
              />
            </p>
            <p className="textTransformNone">
              {component === "quotation-terms" ? (
                <Highlighter
                  className="textTransformNone"
                  searchWords={searchWords}
                  autoEscape={true}
                  textToHighlight={sliceWords(l.remark || "-") || "-"}
                />
              ) : (
                <Highlighter
                  className="textTransformNone"
                  searchWords={searchWords}
                  autoEscape={true}
                  textToHighlight={sliceWords(l.remarks || "-") || "-"}
                />
              )}
            </p>
            <div key={l.id}>
              <input
                type="checkbox"
                className="toggle toggle-error"
                onChange={(e) => onStatusChanger(e, l.id)}
                defaultChecked={l.status === "Active" ? true : false}
                disabled={
                  !checkAccess("Quotation", "quotation-cost-sheet-edit")
                }
              />
            </div>

            <div className="flex gap-3 min-w-fit ">
              {checkAccess("Quotation", "quotation-cost-sheet-edit") ? (
                <button
                  className="p-1 px-2 rounded-md ring-1 ring-slate-600"
                  onClick={() =>
                    editData(l.id, l.particulars, l.remark, l.status)
                  }
                  disabled={loading.edit}
                >
                  {loading.edit && loading.loadingId === l.id ? (
                    <CgSpinner className="animate-spin mx-auto" />
                  ) : (
                    <CiEdit size={"1.4rem"} />
                  )}
                </button>
              ) : (
                <p className="p-1 px-2 rounded-md ring-1 ring-slate-300">--</p>
              )}

              {checkAccess("Quotation", "quotation-cost-sheet-delete") ? (
                <button
                  className="p-1 px-2 rounded-md ring-1 ring-red text-white bg-red"
                  onClick={() =>
                    deleteData((oldState) => ({ open: true, id: l.id }))
                  }
                  disabled={loading.delete}
                >
                  {loading.delete && loading.loadingId === l.id ? (
                    <CgSpinner className="animate-spin mx-auto" />
                  ) : (
                    <MdDeleteOutline size={"1.4rem"} />
                  )}
                </button>
              ) : (
                <p className="p-1 px-2 rounded-md ring-1 ring-slate-300">--</p>
              )}
            </div>
            <hr
              className={`border-[1.5px] border-slate-100  w-full col-span-5 `}
            />
          </React.Fragment>
        ))}
      </div>
      <Pagination />
    </div>
  );
}
